import { FolderEntites } from "@/services/folders/types";

export interface VscFile {
    id: string,
    name: string,
    folderId: string,
    originalFileId: string,
    thumbnailId: string | null,
    isNew: boolean,
    status?: Status,
    percentage: number,
    mediaType: MediaType,
    height: number,
    width: number,
}

export enum Status {
    uploading,
    done,
    error
}

export interface FileInfo {
    name: string,
    height: number,
    width: number,
    folderPath: string
}

export interface FilesFilterDtoIn {
    mediaTypes: MediaType[],
    currentPage: number,
    pageSize: number,
    searchQuery: string,
    folderId: string,
    folderEntity: FolderEntites
}

export interface FilesFilterDtoOut {
    files: VscFile[],
    totalCount: number
}

export interface FilesDuplicatesDtoIn {
    folderId: string,
    files: string[]
}

export enum MediaType {
    Image,
    Video,
    Document
}

export interface FileNameUpdateDtoIn {
    id: string,
    name: string
}

export interface FileInUsePost{
    postId: string,
    postName: string,
    channelId: string,
    createdBy: string,
    userHasAccessToChannel: boolean
}
export interface FileInUseTemplate {
    templateId: string,
    templateName: string,
    templateType: string
}

export interface FileUsageResult {
    posts: FileInUsePost[],
    templates: FileInUseTemplate[]
}

export interface UnsplashImageDtoIn {
    downloadLink: string
    artistName: string
    imgDescription: string
}
